function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.716 12.845a5.704 5.704 0 010-8.156c2.287-2.252 5.996-2.252 8.284 0 2.288-2.252 5.997-2.252 8.284 0a5.704 5.704 0 010 8.155L12 21l-8.284-8.155z",
  fill: "#fff"
});

function SvgIconHeartWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNzE1NzMgMTIuODQ0NUMxLjQyODA5IDEwLjU5MjQgMS40MjgwOSA2Ljk0MTEyIDMuNzE1NzMgNC42ODkwNUM2LjAwMzM2IDIuNDM2OTggOS43MTIzNiAyLjQzNjk4IDEyIDQuNjg5MDVDMTQuMjg3NiAyLjQzNjk4IDE3Ljk5NjYgMi40MzY5OCAyMC4yODQzIDQuNjg5MDVDMjIuNTcxOSA2Ljk0MTEyIDIyLjU3MTkgMTAuNTkyNCAyMC4yODQzIDEyLjg0NDVMMTIgMjFMMy43MTU3MyAxMi44NDQ1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconHeartWhite as ReactComponent };